<template>
  <div class="rest touch" @click="handleClick">
    <div
      v-if="restOverride && configs.restMedia.length > 0"
      class="rest__override" 
    >
      <video  
          v-if="assetType(configs.restMedia[restIndex]) === 'video'"
          class="rest__background-media" 
          :src="`${$store.state.assetsPath}${configs.restMedia[restIndex]}`"
          autoplay
          loop
          disablePictureInPicture
          muted
        ></video>
        <img
          v-if="assetType(configs.restMedia[restIndex]) === 'image'"
          class="rest__slide-image" 
          :src="`${$store.state.assetsPath}${configs.restMedia[restIndex]}`"
        >    
    </div>
    <tiny-slider 
      v-if="!restOverride && configs.restMedia && configs.restMedia.length > 0" 
      class="rest__slides"
      v-bind="sliderConfig"
    >
      <div
        v-for="asset in configs.restMedia"
        :key="asset"
      >
        <video
          v-if="assetType(asset) === 'video'"
          class="rest__background-media" 
          :src="`${$store.state.assetsPath}${asset}`"
          autoplay
          disablePictureInPicture
          loop
          muted
        ></video>
        <img
          v-if="assetType(asset) === 'image'"
          class="rest__slide-image" 
          :src="`${$store.state.assetsPath}${asset}`"
        >
      </div>
    </tiny-slider>
    <div class="rest__title">
      {{ configs.restTitle }}
    </div>
    <div class="rest__prompt-wrapper">
      <img 
        class="rest__touch-prompt" 
        :class="{ 'rest__touch-prompt--visible': showTouchPrompt }"
        src="/assets/touch-prompt.png"
      >
      <div class="rest__touch-label" :class="{ 'rest__touch-label--visible': showTouchPrompt }" v-html="configs.restCta"></div>
    </div>
    <img
      v-if="configs.restCompanyLogo"
      class="rest__company-logo"
      :src="`${$store.state.assetsPath}${configs.restCompanyLogo}`"
    >
    <img
      v-if="configs.restDevelopmentLogo"
      class="rest__development-logo"
      :src="`${$store.state.assetsPath}${configs.restDevelopmentLogo}`"
    >
    <div class="rest__overlay" :style="`opacity: ${configs.restOverlay / 100};`"></div>
  </div>
</template>
<script>
import TinySlider from 'vue-tiny-slider';
import { mapActions } from 'vuex'
export default {
  name: 'rest',

  components: { TinySlider },

  data () {
    return {
      restIndex: false,
      restOverride: false,
      sliderConfig: {
        mode: "gallery",
        autoplay: true,
        autoplayTimeout: 7500,
        autoplayButton: false,
        autoplayButtonOutput: false,
        mouseDrag: false,
        controls: false,
        loop: true,
        items: 1,
        gutter: 0,
        nav: false,
        speed: 1200,
        animateIn: 'background--show',
        animateOut: 'background--hide',        
      }
    }
  },

  computed: {
    configs () {
      const restCompanyLogo = this.$store.state.config.restCompanyLogo
      const restDevelopmentLogo = this.$store.state.config.restDevelopmentLogo
      const restCta = this.$store.state.config.restCta ? this.$store.state.config.restCta[this.language.code] : null
      const restMedia = this.$store.state.config.restMedia ? this.$store.state.config.restMedia : []
      const restTitle = this.$store.state.config.restTitle ? this.$store.state.config.restTitle[this.language.code] : null
      const restOverlay = this.$store.state.config.restBackgroundOverlay ? parseInt(this.$store.state.config.restBackgroundOverlay) : 0

      return {
        restCompanyLogo,
        restDevelopmentLogo,
        restCta,
        restMedia,
        restTitle,
        restOverlay
      }
    },

    language () {
      return this.$store.getters.language
    },

    showTouchPrompt () {
      return !this.$store.state.isBottomBarVisible
    }
  },

  created () {
    this.checkRestIndexQuery()
  },

  methods: {
    ...mapActions([
      'toggleBottomBarVisibility',
    ]),

    assetType (path) {
      if (path.split('.').pop() === 'mp4') {
        return 'video'
      }

      return 'image'
    },

    checkRestIndexQuery () {
      if (typeof this.$route.query.restIndex !== 'undefined') { document.cookie = `restIndex=${this.$route.query.restIndex}`}
      const restIndex = document.cookie.replace(/(?:(?:^|.*;\s*)restIndex\s*=\s*([^;]*).*$)|^.*$/, '$1')
      if (typeof restIndex !== 'undefined') { 
        this.restIndex = parseInt(restIndex)
        this.restOverride = (typeof this.restIndex === 'number' && !isNaN(this.restIndex))
      }
    },

    handleClick () {
      // TODO remove this later, hard coded because i'm lazy
      this.$router.push('/select').catch(() => {
        // navigating to this route "fails" if we skip it with the route guard in router.js (and we skip it if there is only 1 category, no need to show category selection in this case)
        // the "failed" navigation causes a console error, this catch supresses that error (because in our case, it's not an error 👍🏻)
        // see https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
      })      
    }
  }
}
</script>
<style lang="scss">
.rest {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &__slide-image {
    height: 108rem;
    width: 192rem;
    object-fit: cover;
  }

  &__background-media {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  &__company-logo {
    position: absolute;
    opacity: 1;
    right: 0;
    top: 0;
    width: 20rem;
    z-index: 10;
  }

  &__development-logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50rem;    
    z-index: 10;
  }

  &__prompt-wrapper {
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute; 
    text-align: center;
    z-index: 10;
  }

  &__title {
    font-size: 11.5em;
    font-weight: bold;
    left: 0;
    letter-spacing: 0.09em;
    opacity: 0.2;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    z-index: 10;
  }
  
  &__touch-prompt {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    width: 7rem;
    margin-bottom: 2rem;
    z-index: 10;

    &--visible {
      animation: pulse 4s ease-in-out 0.6s infinite;
      transition: opacity 0.3s ease-in-out 0.3s;
      opacity: 0.7;
    }
  }

  &__touch-label {
    font-size: 4rem;
    opacity: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    z-index: 10;

    &--visible {
      animation: pulse 4s ease-in-out 0.6s infinite;
      transition: opacity 0.3s ease-in-out 0.3s;
      opacity: 0.7;
    }    
  }

  &__overlay {
    background: rgba(0, 0, 0, 1);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 5;
  }


  @keyframes pulse {
    0% {  transform: scale(1); opacity: 0.7; }
    5% { transform: scale(1.1); opacity: 1; }
    10% { transform: scale(1);}
    15% { transform: scale(1.1); opacity: 1; }
    20% { transform: scale(1); opacity: 0.7; }
    100% { transform: scale(1); opacity: 0.7; }
  }  
}
</style>
